export enum GlidStatus {
  PENDING = 'Pending',
  RESERVED = 'Reserved',
  UNRESERVED = 'Unreserved',
}
